import React from 'react'
import { DropdownButton, MenuItem } from 'react-bootstrap'


const rfSelect = ({ values, selectedDataEntity, defaultLabel, buttonLabel, title, selectedValue, menuAlign, input, onClick, colorType, type }) => {

  return(
    <div onClick={onClick}> 
      {title && <span className="labelz">{title}</span>}
      <div style={{marginLeft: '-.25rem'}} 
        className="lingk-dropdown-menu-wrapper">
        <DropdownButton value={selectedValue || "choose"} id={`rf-select-${defaultLabel}`}
          className={`rf-select${selectedValue ? '' : ' rf-select-unselected'}`}
          bsStyle={type==='brand'?'primary':'default'} 
          title={selectedValue ? selectedValue : buttonLabel || defaultLabel}
          >
          <MenuItem disabled style={{background:'rgb(238, 238, 238)',color:'rgb(170, 170, 170)'}} value="choose">
            {defaultLabel}
          </MenuItem>
          {values && values.map((val, i)=>
            <MenuItem value={val.label} key={i} onClick={()=>input.onChange(val.label)}
              style={{height:20, padding:'1px 8px'}}>
              {val.label}
            </MenuItem>
          )}
        </DropdownButton>
      </div>
    </div>
  )
}

export default rfSelect


// WEBPACK FOOTER //
// ./src/lib/themes/lingk/rfSelect.js